<template>
  <div class="toolBar">
    <div class="side1">
      <div @click="concatUs()">
        
        <span>联系我们</span>
      </div>
    </div>
    <div class="side2 side">
      <a href="tel:400-1331-551">
        <i>
          <img
            src="/static/image/icon_phone_cehua@2x.png"
            alt=""
            title=""
            la="la"
            class="left_img"
          />
        </i>
        <span>400-1331-551</span>
      </a>
    </div>
    <div class="side3 side">
      <a href="mailto:business@cnewmedical.com">
        <i>
          <img 
            src="/static/image/icon_email_cehua@2x.png"
            alt=""
            title=""
            la="la"
            class="left_img"
          />
        </i>
        <span>business@cnewmedical.com</span>
      </a>
    </div>
    <div class="side5 side">
      <a>
        <i>
          <img
            src="/static/image/icon_wechat_cehua@2x.png"
            alt=""
            title=""
            la="la"
            class="left_img"
          />
        </i>
        <span>关注我们</span>
      </a>
      <div class="qcodePic animated fadeInUp">
        <img
          src="/static/image/img_gongzhonghao_cehua@2x.png"
          alt=""
          title=""
          la="la"
          class="gongzhonghao_img"
        />
      </div>
    </div>
 
  </div>
</template>

<script>
import { mapState,mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Footer,
  },
  computed:{
      ...mapState(["joinusPageCurrentSelected"])

  },
 
  data() {
    return {
    };
  },
  methods: {
    ...mapMutations(["changeHeaderIndex","changeaboutPageCurrentSelected","changehxjsPageCurrentSelected","changecpzxPageCurrentSelected","changejoinusPageCurrentSelected"]),

      concatUs() {
      window.localStorage.setItem('index', 6);
      this.changeHeaderIndex(6);
      this.changejoinusPageCurrentSelected(3);
      this.$router.push({ name: "contactUs" ,params:{
        selectedNuber:3
      }});
    }
  },
};
</script>



<style lang="scss" scoped>
.toolBar {
  position: fixed;
  right: 0;
  top: 40%;
  transform: translateY(-50%);
  z-index: 998;
}

.side1 {
  width: 36px;
  height: 92px;
  background: #00479E;
  text-align: center;
  transition: all 0.5s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left_img{
    width: 36px;
    height: 36px;
}
// .gongzhonghao_img{
  

// }
.side1 a,
.side1 img,
.side1 i,
.side1 span {
  display: block;
}

.side1 img {
  margin: 0 auto;
}

.side1 i {
  margin: 10px auto;
  width: 1px;
  height: 20px;
  background: #fff;
  transition: all 0.5s ease;
}

.side1 span {
  color: #fff;
  font-size: 14px;
  writing-mode: vertical-lr;
  margin: 0 auto;
  letter-spacing: 2px;
}

.side1:hover {
  background-image: linear-gradient(to right,  #186DD5 0%, #0549A2 100%);
}

.side1:hover a img {
  animation: jitter 0.5s;
}

.side {
  height: 36px;
  position: absolute;
  transition: all 0.5s;
}

.side a {
  display: block;
  height:36px;
  font-size: 0;
}

.side i,
.side span {
  display: inline-block;
  vertical-align: middle;
  height: 100%;
  line-height: 36px;
}

.side i {
  width: 36px;
  text-align: center;
  background: #fff;
  transition: all 0.3s;
  boeder: 1px #01679c solid;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
}

.side i img {
  vertical-align: middle;
}

.side span {
  text-align: center;
  line-height: 36px;
  background: #00479E;
  font-size: 13px;
  color: #fff;
  transition: all 1s;
}

.side2 {
  top: 93px;
  right: -140px;
  width: 176px;
}

.side2 span {

  width: 140px;
}

.side3 {
  right: -190px;
  width: 226px;
  top: 129px;
}

.side3 span {
  width: 190px;
}

.side4 {
  right: -140px;
  width: 190px;
  top: 165px;
}

.side4 span {
  width: 140px;
}

.side5 {
  right: -90px;
  width: 126px;
  top: 165px;
  cursor: pointer;
}

.side5 span {
  width: 90px;
  font-size: 14px;
}

.qcodePic {
  width: 100%;
  height: 100px;
  position: absolute;
  top: 36px;
  left: 0;
  display: none;
  z-index: 99;
  text-align: center;
  background: #fff;
  border: 1px solid #e5e5e5;
}

.qcodePic img {
  width: 100%;
}

.side5:hover .qcodePic {
  display: block;
}

.side6 {
  right: -90px;
  width: 140px;
  top: 305px;
  cursor: pointer;
}

.side6 span {
  width: 90px;
  font-size: 14px;
}

.side:hover {
  right: 0;
}

.side:hover i {
  background: #fff;
}

</style>


// WEBPACK FOOTER //
// src/components/RightTool.vue